<template>
  <div>
    <el-container style="width:100%;height:100%;position:absolute;overflow:hidden;">
      <!---------------- 头部 ------------------->
      <el-header style="padding:10px 0 10px 0;">
        <!-------- 头部最左侧LOGO ---------->
        <el-button type="primary" @click="openandclose"
          style="float:left;padding:0 0 0 1%;height:100%;border:0;background:none">
          <template><img src="../assets/logo.png" style="height:96%;top:2%" /></template>
        </el-button>
        <!-------- 代理商名称 -------------->
        <div style="float:left;margin-left:0;">
          <span style="float:left;color:#fff;font-size:.9rem;margin-top:.7rem">{{ agentname }}</span>
          <span style="float:left;font-size:.7rem;color:#fff;margin-left:.7rem;margin-top:.8rem">
            <i style="float:left;font-style:normal;color:#fff;font-size:.7rem">（</i>
            <img src="../assets/addresswhite.png" style="float:left;width:.7rem;height:.7rem;margin-top:.2rem" />
            <i style="float:left;margin-top:.1rem;margin-left:.3rem;font-style:normal">{{ cityname }}</i>
            <i style="float:left;font-style:normal;color:#fff;font-size:.7rem">）</i>
          </span>
        </div>

        <!------------ 头部右侧用户名及退出按钮 ---------->
        <div style="float:right;margin-right:2%;margin-top:.5rem">
          <el-dropdown style="color:#fff;height:100%;border:0;" size="medium" @command="handleCommand">
            <span class="el-dropdown-link">{{ truename }}<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!----------------- 头部右侧用户头像 ------------>
        <div
          style="width:35px;height:35px;float:right;margin-right:1%;margin-top:2.5px;border-radius:50%;overflow:hidden;display:flex;justify-content:center;align-items:center;background:#fff;border:1px solid #dddddd">
          <img src="../assets/manager-logo.png"
            style="width:33px;height:33px;border-radius:50%;border:1px solid #dddddd"
            v-if="thumb == '' || thumb == null" />
          <img :src="thumb" style="width:33px;height:33px;border-radius:50%;border:1px solid #dddddd"
            v-if="thumb != ''" />
        </div>
        <div style="height:20px;float:right;margin-right:2%;margin-top:10px;border-left:1px solid #fff"></div>
        <!----------------- 消息提示 ------------------->
        <div
          style="width:35px;height:35px;float:right;margin-right:1.5%;margin-top:2.5px;border-radius:30px;overflow:hidden;text-align:center;">
          <a href="javascript:;" @click="checknotice">
            <img src="../assets/anotice.png" style="height:60%;margin-top:20%">
            <span v-if="noticeLists.length > 0"
              style="width:8px;height:8px;border-radius:15px;background:#F56C6C;position:absolute;"></span>
          </a>
        </div>
        <div
          style="width:35px;height:35px;float:right;margin-top:2.5px;border-radius:30px;overflow:hidden;text-align:center;">
          <a href="javascript:;" @click="drawandcontract">
            <img src="../assets/contract.png" v-if="istraw" style="height:60%;margin-top:20%">
            <img src="../assets/draw.png" v-if="!istraw" style="height:60%;margin-top:20%">
          </a>
        </div>
      </el-header>

      <!-------------------- 框架左边和右边内容 ---------------->
      <el-container>
        <!---------- 左边菜单栏 ------------>
        <el-aside :style="leftwidth">
          <div class="menulists">
            <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse"
              background-color="#2f3036" text-color="#fff" style="border:0;margin-top:25px">
              <el-submenu v-if="item.isshow == 1" v-for="(item, index) in menu" :key="index"
                :index="item.menuindex + ''" style="padding:5px 0">
                <template slot="title">
                  <img :src="require('../assets/menuicon/' + item.icon + '-white.png')" class="clb-menu-logo" />
                  <span>{{ item.name }}</span> 
                  <!-- 库存管理 -->
                </template>

                <div v-for="(t, i) in item.child" :key="i">
                  <el-submenu v-if="t.childnumnumber > 0 && item.isshow == 1" :index="t.menuindex + ''" :key="i">
                    <template slot="title">
                      <span>{{ t.name }}</span>
                      <!-- 库存列表 -->
                    </template>
                    <el-menu-item v-if="tt.isshow == 1 && tt.name != '批次记录'" v-for="(tt, ii) in t.child" :key="ii" :index="tt.menuindex"
                      @click="selectmenu(tt)">{{ tt.name }}</el-menu-item>
                      <!-- 商品库存 -->
                  </el-submenu>
                  <el-menu-item v-if="t.childnumnumber == 0 && t.isshow == 1" :key="i" :index="t.menuindex + ''"
                    @click="selectmenu(t)">{{ t.name }}</el-menu-item>
                </div>
              </el-submenu>
            </el-menu>
          </div>
        </el-aside>

        <!----------- 右侧主要内容 ------------>
        <el-main :style="rightmain">
          <div class="righthead">
            <div class="rightheadtags">
              <el-tabs v-model="tagnum" type="card" closable @tab-remove="removeTab" size="small" @tab-click="selmenu">
                <el-tab-pane class="tagsshowlists" v-for="(item, index) in tags" :key="index" :label="item.name"
                  :name="item.num"></el-tab-pane>
              </el-tabs>
            </div>
            <div class="rightheadbutton">
              <el-button type="info" size="mini" icon="el-icon-close" circle @click="closeAllwindows"></el-button>
            </div>
          </div>
          <div class="maincontent">
            <div class="maincontentcase" :style="insidecss" v-for="(item, index) in tags" :key="index"
              :index="index + ''" v-if="item.isselect == true">
              <component :ref="item.url" :is="item.url" @listenchild="listenchild" @closechild="closechild"
                @cannelnotice="cannelnotice" :childdata="childdata">
              </component>
            </div>
            <div class="maincontentcase" :style="insidecss" v-for="(item, index) in tags" :key="index"
              :index="index + ''" v-if="item.isselect == false">
              <component :ref="item.url" :is="item.url" @listenchild="listenchild" @closechild="closechild"
                @cannelnotice="cannelnotice" :childdata="childdata">
              </component>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!--- 查看提示列表信息 --->
    <el-dialog title="系统消息" :visible.sync="noticeDialog" width="38%" top="20vh">
      <!-- 有消息界面 -->
      <div v-if="noticeLists.length > 0">
        <el-col :span="24" style="margin-bottom:25px" v-for="(item, index) in noticeLists" :key="index">
          <el-tag type="danger"
            style="color:#fff;background:#F56C6C;border-color:#F56C6C;padding:.3rem .4rem;height:1.5rem;line-height:.8rem">{{
              item.title }}</el-tag>
          <span style="margin-left:1%">{{ item.name }}</span>
          <el-button type="primary" size="mini" icon="el-icon-view"
            style="float:right;margin-right:5%;padding:.3rem .4rem"
            @click="gotonotice(item.showname, item.url)">马上查看</el-button>
        </el-col>
      </div>

      <!-- 无消息界面 -->
      <div v-if="noticeLists.length == 0">
        <el-col :span="24" style="margin-bottom:10px;text-align:center;color:#909399">
          当前无任何消息提醒
        </el-col>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="noticeDialog = false" style="margin-top:15px">取 消</el-button>
      </div>
    </el-dialog>

    <audio id="audio" :src="noticemp3" />

  </div>
</template>


<script>
//订单管理
import Sell from '@/components/home/Sell'  //销售订单
import Selladd from '@/components/home/Selladd' //添加销售订单
import Selledit from '@/components/home/Selledit' //编辑销售订单
import Sellorder from '@/components/home/Sellorder'  //销售单
import Allot from '@/components/home/Allot'  //商品调拨
import Allotadd from '@/components/home/Allotadd'  //新增商品调拨
import Refund from '@/components/home/Refund'  //商品退货
import Refundadd from '@/components/home/Refundadd' //新增退货订单
import Refundedit from '@/components/home/Refundedit' //编辑退货订单
import Pdorder from '@/components/home/Pdorder' //业务员下单
import Makeinventory from '@/components/home/Makeinventory' //库存盘点
import Makeinventoryadd from '@/components/home/Makeinventoryadd' //新增库存盘点
import yborder from '@/components/home/yborder' //有贝订单
import sellshippingbirld from '@/components/home/sellshippingbirld' //快递鸟快递单管理
import checkshippings from '@/components/home/checkshippings' //查询快递信息
import sellprinter from '@/components/home/print/printer'
import sellprint from '@/components/home/print/sellprint' //二次分拣出库单
import ExpressStatistics from '@/components/home/ExpressStatistics' // 快递面单统计
import ExpressDeliveryUsage from '@/components/home/ExpressDeliveryUsage' // 快递面单使用情况
import ExpressRecycling from '@/components/home/ExpressRecycling' // 回收快递列表情况

//采购管理
import Storage from '@/components/purchase/Storage'  //进货入库
import Storageadd from '@/components/purchase/Storageadd'  //编辑进货入库
import Storageedit from '@/components/purchase/Storageedit'  //编辑进货入库
import Purcharorder from '@/components/purchase/order'  //采购单
import Purcharorderkingdee from '@/components/purchase/orderkingdee'  //采购单金蝶版
import Purcharorderadd from '@/components/purchase/orderadd' //新增采购单
import Purcharorderedit from '@/components/purchase/orderedit' //编辑采购单
import Purcharrefund from '@/components/purchase/Purcharrefund' //采购退货
import Purcharrefundadd from '@/components/purchase/Purcharrefundadd' //新增采购退货
import Purcharrefundedit from '@/components/purchase/Purcharrefundedit' //编辑采购退货

//线上商城管理
import Goods from '@/components/mall/Goods'
//import Goodspush from '@/components/mall/Goodspush' //商品信息发布
import Goodspush from '@/components/mall/Goodspushnew'
import Goodspushinfo from '@/components/mall/Goodspushinfonew'

import Goodsspecial from '@/components/mall/Goodsspecial' //商品专区管理
import Order from '@/components/mall/Order'
import Orderedit from '@/components/mall/Orderedit' //订单修改
import OrderVerify from '@/components/mall/Orderverify' //特批单审核
import Combination from '@/components/mall/Combination' //组合管理
import CombinationEdit from '@/components/mall/CombinationEdit' //组合管理 新增/编辑
import Offers from '@/components/mall/Offers'
import Offersactiveadd from '@/components/mall/Offersactiveadd' //新增促销活动
import Offersactiveedit from '@/components/mall/Offersactiveedit' //编辑促销活动
import Offersnew from '@/components/mall/Offersnew' //新人专区活动
import Offerschange from '@/components/mall/Offerschange' //换购专区活动
import Offersspecial1 from '@/components/mall/Offersspecial1' //热卖专区活动1
import Offersspecial2 from '@/components/mall/Offersspecial2' //热卖专区活动2
import Offerscut from '@/components/mall/Offerscut' //秒杀专区活动
import Offerspintuan from '@/components/mall/Offerspintuan' //拼团专区活动
import Sysoffers from '@/components/mall/Sysoffers' //平台营销活动
import Sysoffersjoin from '@/components/mall/Sysoffersjoin' //报名参加平台营销活动
import Mallsalechart from '@/components/mall/mallsalechart' //线上销售数据看板
import Mallwallet from '@/components/mall/mallwallet' //我的钱包
import OrderAfter from '@/components/mall/OrderAfter'
import SysGoodsinventory from '@/components/mall/SysGoodsinventory' //批量同步商品库存信息

import Paysetting from '@/components/mall/Paysetting'
import Paysettingxiaoye from '@/components/mall/Paysettingxiaoye' //小也支付管理
import Shippingarea from '@/components/mall/Shippingarea'
//import Shippingarea1 from '@/components/mall/Shippingarea1'
import Shippingarea1 from '@/components/mall/shippingtemp/Shippingtempnews1' //运费模板
import Labelsetting from '@/components/mall/Labelsetting'
import Shippingtemp from '@/components/mall/Shippingtemp' //运费模板
import Shippingweight from '@/components/mall/Shippingweight' //运费重量
import Freetemp from '@/components/mall/Freetemp' //免邮模板
import Brandtemp from '@/components/mall/Brandtemp' //品牌模板
import Balancetemp from '@/components/mall/Balancetemp' //预存款模板
import Labelandcatid from '@/components/mall/Labelandcatid' //标签分类管理商品分类
import Coupon from '@/components/mall/Coupon' //优惠券
import Coupondetail from '@/components/mall/Coupondetail' //优惠券
import Ad from '@/components/mall/Ad'
import Adadd from '@/components/mall/Adadd' //添加广告
import Adedit from '@/components/mall/Adedit' //添加广告
import Splitorder from '@/components/mall/Splitorder' //分销订单管理
import Draws from '@/components/mall/Draws' //抽奖管理
import Drawsadd from '@/components/mall/Drawsadd' //新增抽奖管理
import Drawsedit from '@/components/mall/Drawsedit' //编辑抽奖管理
import Award from '@/components/mall/award' //中奖纪录管理
import Packetfund from '@/components/mall/packetfund' //中奖红包提现流水
import Mallsalestat from '@/components/mall/Mallsalestat' //线上商城销售统计
import Mallsaledays from '@/components/mall/Mallsaledays' //线上商城销售日结
import Mallsalegoods from '@/components/mall/Mallsalegoods' //线上商城商品统计
import Mallsaleanalyse from '@/components/mall/Mallsaleanalyse' //线上商城销售分析
import Mallpercent from '@/components/mall/Mallpercent' //线上商城提成计算
import Mallsalesshop from '@/components/mall/mallsalesshop' //店铺销售统计
import Mallsalesshopdetail from '@/components/mall/mallsalesshopdetail' //店铺销售统计
import Mallsalesuser from '@/components/mall/mallsalesuser' //店铺会员销售统计
import Mallsalesuserdetail from '@/components/mall/mallsalesuserdetail' //店铺会员销售统计
import Mallsalesreplacedetail from '@/components/mall/mallsalesreplacedetail' //一件代发商品销售统计
import Offersinvitation from '@/components/mall/Offersinvitation'
import Offersinvitationlog from '@/components/mall/Offersinvitationlog'
import Offersinvitateelog from '@/components/mall/Offersinvitateelog'


import TMallSettings from '@/components/tmall/TMallSettings' //天猫店铺配置
import TMallGoods from '@/components/tmall/TMallGoods' //天猫商品管理
import TMallOrders from '@/components/tmall/TMallOrders' //天猫订单管理


import DoudianSettings from '@/components/doudian/DoudianSettings' //抖店店铺配置
import DoudianGoods from '@/components/doudian/DoudianGoods' //抖店商品管理
import DoudianOrders from '@/components/doudian/DoudianOrders' //抖店订单管理


import PinddSettings from '@/components/Pindd/PinddSettings' //拼多多模块配置
import Pinddmatch from '@/components/Pindd/Pinddmatch' //拼多多商品匹配模块
import Pinddorder from '@/components/Pindd/Pinddorder' //拼多多订单管理



//数据统计
import StatOrder from '@/components/stat/Order'
import StatTardyGoods from '@/components/stat/Tardy'
import StatProduct from '@/components/stat/Product'
import StatCustomer from '@/components/stat/Customerstat'
import StatFund from '@/components/stat/Fund'
import StatCollection from '@/components/stat/Collection'
import StatAccount from '@/components/stat/Account'
import StatStorage from '@/components/stat/Storage'
import StatReport from '@/components/stat/Report'
import StatGetaccount from '@/components/stat/Accountstat'
import StatPayaccount from '@/components/stat/Paystat'
import StatSale from '@/components/stat/StatSale'
import StatSaletoCustomer from '@/components/stat/StatSaletoCustomer'
import Statdatashow from '@/components/stat/statdatashow' //线下销售数据看板
import Managestate from '@/components/stat/Managestate' //经营状况
import Managestatefund from '@/components/stat/Managestatefund' //经营流水
import Profitreport from '@/components/stat/Profitreport' //利润报告
import Debt from '@/components/stat/Debt' //资产负债
import StatmallSale from '@/components/stat/StatmallSale'
import mallsellstats from '@/components/stat/mallsellstats'
import mallselldetail from '@/components/stat/mallselldetail'
import malldaystats from '@/components/stat/malldaystats'
import managementOfInvoices from '@/components/stat/managementOfInvoices'
import Exportsyndata from '@/components/mall/exportsyndata' //导出数据同步记录

//店铺管理
import ShopLists from '@/components/shop/Lists'
import ShopStat from '@/components/shop/stat'

//统计报表
import Customervisit from '@/components/report/Customervisit' //客户拜访统计
import StatSellandStorage from '@/components/stat/StatSellandStorage' //进销存统计

//信息管理
import Customer from '@/components/base/Customer'
import Customeradd from '@/components/base/Customeradd'
import Customermoreadd from '@/components/base/Customermoreadd'
import Customeredit from '@/components/base/Customeredit'
import Customercate from '@/components/base/Customercate'
import Customerdistrict from '@/components/base/Customerdistrict'
import Customerdeposit from '@/components/base/Customerdeposit'
import Customerlevel from '@/components/base/Customerlevel' //客户等级管理
import ApplyCollection from '@/components/base/ApplyCollection' //供应商账本
import Percent from '@/components/base/Percent'
import Percentadd from '@/components/base/Percentadd'
import Percentedit from '@/components/base/Percentedit'
import Clerk from '@/components/base/Clerk'
import Clerkadd from '@/components/base/Clerkadd'
import Clerkedit from '@/components/base/Clerkedit'
import Clerkgroup from '@/components/base/Clerkgroup'
import Clerkrun from '@/components/base/Clerkrun'
import Clerkcustomer from '@/components/base/Clerkcustomer'
import Account from '@/components/base/Account'
import Accountadd from '@/components/base/Accountadd'
import Accountedit from '@/components/base/Accountedit'
import Express from '@/components/base/Express'

//库存记录
import Lists from '@/components/inventory/Lists'
import Product from '@/components/inventory/Product'
import JDProduct from '@/components/inventory/JDProduct'
import Productadd from '@/components/inventory/Productadd'
import Productaddmore from '@/components/inventory/Productaddmore'
import Productbrand from '@/components/inventory/Productbrand'
import Productcate from '@/components/inventory/Productcate'
import Productsupply from '@/components/inventory/Productsupply'
import iSell from '@/components/inventory/Sell'
import iStorage from '@/components/inventory/Storage'
import Warehouse from '@/components/inventory/Warehouse'
import StorageLocation from '@/components/inventory/StorageLocation'
import Warehouseadd from '@/components/inventory/Warehouseadd'
import Warehouseedit from '@/components/inventory/Warehouseedit'
import ShelfLifeWarning from '@/components/inventory/ShelfLifeWarning'
import Warespace from '@/components/inventory/Warespace'
import Jdinventorycheck from '@/components/inventory/Jdinventorycheck'
import Splitagent from '@/components/inventory/Splitagent'
import Showfrozen from '@/components/inventory/frozen'
import Showsalefulture from '@/components/inventory/showsalefulture'
import CostAccount from '@/components/inventory/CostAccount'
import BrandCostAccount from '@/components/inventory/BrandCostAccount'
import CustomerCostAccount from '@/components/inventory/CustomerCostAccount'
import ClerkCostAccount from '@/components/inventory/ClerkCostAccount'



//系统设置
import Manager from '@/components/config/Manager'
import Managercate from '@/components/config/Managercate' //用户分类管理
import Password from '@/components/config/Password'
import Print from '@/components/config/Print'
import Setting from '@/components/config/Setting'
import Sysreset from '@/components/config/Sysreset'

//金蝶对接数据管理
import KDcompy from '@/components/kingdee/KDcompy' //公司组织管理
import KDcustomer from '@/components/kingdee/KDcustomer' //公司组织客户管理
import KDseller from '@/components/kingdee/KDseller' //公司组织销售员管理
import KDgoods from '@/components/kingdee/KDgoods' //公司组织物料管理
import KDapply from '@/components/kingdee/KDapply' //公司组织供应商管理

//金蝶云对接数据管理
import Yungoods from '@/components/kingdeeyun/Yungoods' //金蝶云商品
import Yuncustomers from '@/components/kingdeeyun/Yuncustomers' //金蝶云客户
import Yunclerks from '@/components/kingdeeyun/Yunclerks' //金蝶云销售员

//快递模块


export default {
  components: {
    Sell, Sellorder, Allot, Allotadd, Refund, Refundadd, Refundedit, Pdorder, Makeinventory, Makeinventoryadd, Selladd, Selledit, yborder, sellshippingbirld, checkshippings, sellprinter, sellprint,
    Storage, Storageadd, Storageedit, Purcharorder, Purcharorderkingdee, Purcharorderadd, Purcharorderedit, Purcharrefund, Purcharrefundadd, Purcharrefundedit, Goods, Goodspush, Goodspushinfo, Goodsspecial, Order, Orderedit, OrderVerify, OrderAfter, SysGoodsinventory, Offers, Offersactiveadd, Offersactiveedit, Paysetting, Paysettingxiaoye, Shippingarea, Shippingarea1, Labelsetting, Labelandcatid, Shippingtemp, Shippingweight, Coupon, Ad, Adadd, Adedit, Brandtemp, Freetemp, Exportsyndata, Mallsalestat, Mallsaledays, Mallsalegoods, Mallsaleanalyse, Mallpercent, Balancetemp, Mallsalesshop, Mallsalesshopdetail, Mallsalesuser, Mallsalesuserdetail, StatSaletoCustomer, Offerspintuan, Mallsalesreplacedetail, Showfrozen, Showsalefulture, Offersinvitation, Offersinvitationlog, Offersinvitateelog,
    StatOrder, StatTardyGoods, StatProduct, StatCustomer, StatFund, StatCollection, StatAccount, StatStorage, StatReport, StatGetaccount, StatPayaccount, StatSale, Managestate, Managestatefund, Profitreport, Debt, Statdatashow, Mallwallet,
    ShopLists, ShopStat, StatSellandStorage, Mallsalechart, StatmallSale, mallsellstats, mallselldetail, malldaystats, Splitorder, Draws, Drawsadd, Drawsedit, Award, Packetfund,
    Customervisit, Offersnew, Offerschange, Offersspecial1, Offersspecial2, Offerscut, Sysoffers, Sysoffersjoin, Coupondetail, CostAccount, BrandCostAccount, CustomerCostAccount, ClerkCostAccount,
    Customer, Percent, Percentadd, Percentedit, Clerk, Clerkadd, Clerkedit, Clerkgroup, Clerkrun, Clerkcustomer, Account, Accountadd, Accountedit, Lists, Customeradd, Customermoreadd, Customeredit, Customercate, Customerdistrict, Customerdeposit, Customerlevel, ApplyCollection, Express,
    Product, JDProduct, Productadd, Productaddmore, Productbrand, Productcate, Productsupply, iSell, iStorage, Warehouse, Warehouseadd, Warehouseedit, Warespace, Manager, Managercate, Jdinventorycheck, Splitagent,
    Password, Print, Setting, Sysreset,
    KDcompy, KDcustomer, KDseller, KDgoods, KDapply,
    Yungoods, Yuncustomers, Yunclerks,
    TMallSettings, TMallGoods, TMallOrders,
    PinddSettings, Pinddmatch, Pinddorder,
    DoudianSettings, DoudianGoods, DoudianOrders, Combination, CombinationEdit, 
    ExpressStatistics,ExpressDeliveryUsage, ExpressRecycling,StorageLocation,ShelfLifeWarning,
    managementOfInvoices
  },

  data() {
    return {
      leftwidth: { width: '5%', height: '100%', transition: 'width 0.3s' },
      rightmain: { width: '95%', left: '5%', position: 'absolute', top: '60px', height: '100%', padding: '0', background: '#f0f0f0', overflow: 'hidden', transition: 'left 0.8s' },
      isCollapse: true,
      loading: '',
      menu: [],
      tags: [],
      truename: this.$cookies.get('truename'),
      agentname: this.$cookies.get('agentname'),
      cityname: this.$cookies.get('cityname'),
      tagnum: '1',
      timeoutflag: true,
      nowtime: 0,
      childdata: '',
      localmenu: '',
      noticeDialog: false,
      noticeLists: [],
      noticemp3: this.GLOBAL.domain + "upload/noticefile/notice.mp3",
      stopshowmsg: false,
      messageshow: false,
      thumb: this.$cookies.get('thumb'),
      istraw: false,
      insidecss: { width: '98%', padding: '1%' },
      screenstatus: 0,
    }
  },
  mounted() {
    this.checkLogin(); //检测当前是否在登录状态
    var _this = this;
    //监听屏幕宽度变化
    window.onresize = () => {
      return (() => {
        //按照不同设备调整左右菜单调整
        _this.getagent();
        if (_this.isCollapse == false && _this.istraw == false) {
          //PC端
          if (_this.screenstatus == 0) { _this.leftwidth.width = '15%'; }
          if (_this.screenstatus == 0) _this.rightmain.width = '85%';
          if (_this.screenstatus == 0) _this.rightmain.left = '15%';
          //移动端竖屏
          if (_this.screenstatus == 1) _this.leftwidth.width = '48%';
          if (_this.screenstatus == 1) _this.rightmain.width = '52%';
          if (_this.screenstatus == 1) _this.rightmain.left = '48%';
          //移动端横屏
          if (_this.screenstatus == 2) _this.leftwidth.width = '30%';
          if (_this.screenstatus == 2) _this.rightmain.width = '70%';
          if (_this.screenstatus == 2) _this.rightmain.left = '30%';

        } else if (_this.isCollapse == true && _this.istraw == false) {

          //PC端
          if (_this.screenstatus == 0) { _this.leftwidth.width = '5%'; }
          if (_this.screenstatus == 0) _this.rightmain.width = '95%';
          if (_this.screenstatus == 0) _this.rightmain.left = '5%';
          //手机端竖屏	
          if (_this.screenstatus == 1) _this.leftwidth.width = '17%';
          if (_this.screenstatus == 1) _this.rightmain.width = '83%';
          if (_this.screenstatus == 1) _this.rightmain.left = '17%';
          //手机端横屏
          if (_this.screenstatus == 2) _this.leftwidth.width = '10%';
          if (_this.screenstatus == 2) _this.rightmain.width = '90%';
          if (_this.screenstatus == 2) _this.rightmain.left = '10%';
          _this.rightmain.transition = "left 0.3s";

        } else if (_this.isCollapse == false && _this.istraw == true) {

          _this.leftwidth.width = '0%';
          _this.rightmain.width = '100%';
          _this.rightmain.left = '0%';
          _this.insidecss.width = "100%";
          _this.insidecss.padding = "1% 0";
          _this.rightmain.transition = "left 0.3s";

        } else if (_this.isCollapse == true && _this.istraw == true) {

          _this.leftwidth.width = '0%';
          _this.rightmain.width = '100%';
          _this.rightmain.left = '0%';
          _this.insidecss.width = "100%";
          _this.insidecss.padding = "1% 0";
          _this.rightmain.transition = "left 0.3s";

        }

      })()
    }

    //开始判断设备决定宽度	
    this.getagent();
    if (this.screenstatus == 0) { //PC端
      this.leftwidth.width = '5%';
      this.rightmain.width = '95%';
      this.rightmain.left = '5%';

    } else if (this.screenstatus == 1) { //竖屏
      this.leftwidth.width = '17%';
      this.rightmain.width = '83%';
      this.rightmain.left = '17%';

    } else if (this.screenstatus == 2) { //竖屏
      this.leftwidth.width = '10%';
      this.rightmain.width = '90%';
      this.rightmain.left = '10%';
    }

  },
  methods: {

    /** 判断当前用户是否已登录 **/
    checkLogin() {
      var token = this.$cookies.get("token");
      this.$http.post(this.GLOBAL.domain + "login/index.html", { "token": token, "act": "checklogin" }).then(res => {
        if (res.body.Result > 0) {
          this.$message.error(res.body.Message);
        } else {
          var param = JSON.parse(Base64.decode(res.body.Data));
          if (param.result == false) { this.$router.push('/login'); return false; }
          //添加加载动画
          this.loading = this.$loading({
            lock: true,
            text: '拼命加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.8)'
          });

          this.getMenus(); //加载一级菜单
          this.getactionauthority(); //加载功能菜单权限
          this.getnoticeinfos(); //开启轮循信息

          this.sysmallgoodsdrafs(); //开启循环同步草稿箱信息到服务器

          this.getStorageLocationStatus() // 获取货位功能开关状态

        }
      });
    },
    //   登录时获取货位功能开关状态
    getStorageLocationStatus() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'settinglists', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.settinglists = JSON.parse(Base64.decode(res.data.Data));
          localStorage.setItem('storageLocationStatus', this.settinglists.storage_location);
          localStorage.setItem('batchStatus', this.settinglists.batch_school_period)
        }
      }).catch((res) => {

      });
    },

    //获取当前用户可用的所有菜单
    getMenus() {
      var token = this.$cookies.get("token");
      var groupid = this.$cookies.get("groupid");
      var returnurlids = this.$cookies.get('returnurlids');
      var menuid = '';
      var index = '';

      var resource = this.$resource(this.GLOBAL.domain + "Authority/index");
      resource.save({ act: 'myauthority', token: this.$cookies.get('token'), groupid: groupid }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001' || res.data.Result == '60006') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          //关闭加载动画
          this.loading.close();
          //获取菜单数据
          this.menu = JSON.parse(Base64.decode(res.body.Data));
          console.log("🚀 ~ resource.save ~ this.menu:", this.menu)
          const VERSION_ID = this.menu.length ? this.menu[0].version_id : ''
          localStorage.setItem('version_id', JSON.stringify(Number(VERSION_ID)));
          //获取默认已选中的tags
          this.gettagscookie(returnurlids);
        }
      }).catch((res) => {

      });
    },

    //获取功能性菜单权限（判断是否具有权限操作功能）
    getactionauthority() {
      var token = this.$cookies.get("token");
      var groupid = this.$cookies.get("groupid");
      this.$http.post(this.GLOBAL.domain + "Authority/index.html", { "token": token, groupid: groupid, "act": "actionauthority" }).then(res => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          var data = Base64.decode(res.body.Data);
          this.$cookies.set('actionauth', data);
        }

      });
    },


    /***************** 菜单操作 *************************/
    //展开、收缩菜单列表
    handleOpen(key, keyPath) { console.log(key, keyPath) },
    handleClose(key, keyPath) { console.log(key, keyPath) },

    //判断设备情况
    getagent() {
      var width = document.body.clientWidth;
      if (width >= 960) this.screenstatus = 0; //PC端
      if (width >= 0 && width <= 500) this.screenstatus = 1; //手机竖屏
      if (width > 500 && width < 960) this.screenstatus = 2; //手机横屏
    },

    //展开收起导航菜单
    openandclose() {
      this.getagent();

      if (this.isCollapse == false && this.istraw == false) {
        this.isCollapse = true;
        this.istraw = false;

        //PC端
        if (this.screenstatus == 0) this.leftwidth.width = '5%';
        if (this.screenstatus == 0) this.rightmain.width = '95%';
        if (this.screenstatus == 0) this.rightmain.left = '5%';
        //移动端竖屏
        if (this.screenstatus == 1) this.leftwidth.width = '17%';
        if (this.screenstatus == 1) this.rightmain.width = '83%';
        if (this.screenstatus == 1) this.rightmain.left = '17%';
        //移动端横屏
        if (this.screenstatus == 2) this.leftwidth.width = '10%';
        if (this.screenstatus == 2) this.rightmain.width = '90%';
        if (this.screenstatus == 2) this.rightmain.left = '10%';

      } else if (this.isCollapse == true && this.istraw == false) {
        this.isCollapse = false;
        this.istraw = false;

        //PC端
        if (this.screenstatus == 0) this.leftwidth.width = '15%';
        if (this.screenstatus == 0) this.rightmain.width = '85%';
        if (this.screenstatus == 0) this.rightmain.left = '15%';
        //手机端竖屏	
        if (this.screenstatus == 1) this.leftwidth.width = '48%';
        if (this.screenstatus == 1) this.rightmain.width = '52%';
        if (this.screenstatus == 1) this.rightmain.left = '48%';
        //手机端横屏
        if (this.screenstatus == 2) this.leftwidth.width = '30%';
        if (this.screenstatus == 2) this.rightmain.width = '70%';
        if (this.screenstatus == 2) this.rightmain.left = '30%';
        this.rightmain.transition = "left 0.3s";

      } else if (this.isCollapse == false && this.istraw == true) {
        this.isCollapse = false;
        this.istraw = false;

        //PC端
        if (this.screenstatus == 0) this.leftwidth.width = '15%';
        if (this.screenstatus == 0) this.rightmain.width = '85%';
        if (this.screenstatus == 0) this.rightmain.left = '15%';
        //手机端竖屏	
        if (this.screenstatus == 1) this.leftwidth.width = '48%';
        if (this.screenstatus == 1) this.rightmain.width = '52%';
        if (this.screenstatus == 1) this.rightmain.left = '48%';
        //手机端横屏
        if (this.screenstatus == 2) this.leftwidth.width = '30%';
        if (this.screenstatus == 2) this.rightmain.width = '70%';
        if (this.screenstatus == 2) this.rightmain.left = '30%';
        this.rightmain.transition = "left 0.3s";

      } else if (this.isCollapse == true && this.istraw == true) {
        this.isCollapse = false;
        this.istraw = false;

        //PC端
        if (this.screenstatus == 0) this.leftwidth.width = '15%';
        if (this.screenstatus == 0) this.rightmain.width = '85%';
        if (this.screenstatus == 0) this.rightmain.left = '15%';
        //手机端竖屏	
        if (this.screenstatus == 1) this.leftwidth.width = '48%';
        if (this.screenstatus == 1) this.rightmain.width = '52%';
        if (this.screenstatus == 1) this.rightmain.left = '48%';
        //手机端横屏
        if (this.screenstatus == 2) this.leftwidth.width = '30%';
        if (this.screenstatus == 2) this.rightmain.width = '70%';
        if (this.screenstatus == 2) this.rightmain.left = '30%';
        this.rightmain.transition = "left 0.3s";

      }
    },

    //获取默认已选中的tags（用于页面刷新或系统刚加载时）
    gettagscookie(checkurl = '') {
      var url = '';
      var onemenu = [];
      var twomenu = [];
      var lists = this.$cookies.get('selecttag');

      if (lists == null || lists == '' || lists == 'undefined' || checkurl == '') {
        onemenu = this.menu[0];
        twomenu = onemenu.child[0];
        if (twomenu.childnumnumber == 0) {
          this.tags.push({ name: twomenu.name, num: '1', url: twomenu.url, isselect: true });
          this.$cookies.set('selecttag', JSON.stringify(this.tags));
          this.tagnum = '1';
          this.localmenu = twomenu.url;
        } else {
          this.tags.push({ name: twomenu.child[0].name, num: '1', url: twomenu.child[0].url, isselect: true });
          this.$cookies.set('selecttag', JSON.stringify(this.tags));
          this.tagnum = '1';
          this.localmenu = twomenu.child[0].url;
        }
      } else {
        var num = '1';
        this.tags = JSON.parse(lists);
        var _this = this;

        //跳转至已选中的菜单链接
        this.tags.forEach(function (e, index) {
          if (checkurl != '') { //有指定传值过来时，跳转指定页面
            e.isselect = false;
            if (e.url == checkurl) { num = e.num; _this.localmenu = e.url; e.isselect = true; }
          } else {
            if (e.isselect == true) { num = e.num; _this.localmenu = e.url; }
          }
        });

        this.tagnum = num;
        this.$cookies.set('returnurlids', ''); //清空历史选中导航记录
      }
    },


    /******************** 菜单操作 **************************/
    //点击选择菜单
    selectmenu(item) {
      var _this = this;
      var isexit = 0;
      var issetcookie = 0;
      var url = '';

      if (this.tags.length == 0) { //当前菜单为空
        this.tagnum = '1';
        this.tags.push({ name: item.name, num: '1', url: item.url, isselect: true });
        this.$cookies.set('selecttag', data);
        return false;
      }

      //重置选中菜单type
      this.tags.forEach(function (e, index) {
        _this.tags[index].isselect = false;
        //如该菜单已存在则直接定位到选中该菜单
        if (item.url == e.url) {
          isexit = 1;
          issetcookie = 1;
          _this.tags[index].isselect = true;
          _this.tagnum = e.num;
        }
      });

      //该菜单不存在时将其当做新菜单添加到导航栏      	        	  
      if (isexit == 0) {
        //if(this.tags.length==10) {this.$message.error("请不要选择超过10个菜单");return false;}
        //获取最后一个菜单的位置
        var num = '';
        var lastnum = this.tags.length;
        lastnum--;
        num = this.tags[lastnum].num;
        num++;
        this.tags.push({ name: item.name, num: '' + num + '', url: item.url, isselect: true });
        this.tagnum = '' + num + '';
        issetcookie = 1;
      }

      //更新点开的菜单列表保存
      if (issetcookie == 1) {
        var data = JSON.stringify(this.tags);
        this.$cookies.set('selecttag', data);
      }
    },

    //点击选择当前菜单
    selmenu(tab, event) {
      this.nowtime++;
      if (this.timeoutflag == false) return false;

      var _this = this;
      this.timeoutflag = false;
      setTimeout(function () {
        if (_this.nowtime == 1) { //单击事件
          _this.singleclick();
        } else { //双击事件
          _this.doubleclick(_this.tagnum);
        }
        _this.nowtime = 0;
        _this.timeoutflag = true;
      }, 250);
    },

    //单击菜单选择
    singleclick() {
      var _this = this;
      var url = '';
      this.tags.forEach(function (e, index) {
        _this.tags[index].isselect = false;
        if (_this.tagnum == e.num) { _this.tags[index].isselect = true; url = e.url }
      });

      //取消系统消息提示
      if (url == 'Sell') this.cannelnotice(2);
      if (url == 'Order') this.cannelnotice(1);
    },

    //双击菜单直接将该菜单关闭
    doubleclick(num) {
      this.removeTab(num);
    },

    //关闭当前打开的窗口
    removeTab(num) {
      var number = '';
      var nums = 0;
      this.tags.forEach(function (e, index) { if (num == e.num) number = index });
      this.tags.splice(number, 1);
      this.tags.forEach(function (e, index) { if (e.isselect == true) nums = e.num });

      if (nums == 0 && this.tags.length > 0) {
        var length = this.tags.length;
        length--;
        this.tags[length].isselect = true;
        this.tagnum = this.tags[length].num;
      } else {
        this.tagnum = nums;
      }

      var data = JSON.stringify(this.tags);
      this.$cookies.set('selecttag', data);
    },


    //关闭当前系统内的所有窗口
    closeAllwindows() {
      this.$confirm('温馨提示：您是否确定要关闭系统当前所有打开的窗口', '提示', { type: 'warning' }).then(() => {
        this.tags = [];
        this.$cookies.set('selecttag', '');
        this.localmenu = ''; //清除当前正在展示的组件
      }).catch(() => {

      });
    },

    //监听子组件点击功能窗口打开
    listenchild(data) {
      //取消系统消息提示
      if (data.url == 'Sell') this.cannelnotice(2);
      if (data.url == 'Order') this.cannelnotice(1);

      this.selectmenu(data);
      //子类传参到父类  		  
      if (data.data) this.childdata = data.data;

      //子类传递参数到父类，此处为将传递的参数转传递给其它兄弟子类，父类只负责中转
      if (data.data && data.data.isreset == true) {
        this.temporaryurl = data.url;
      }
    },


    //监听子子组件关闭
    closechild(url) {
      var num = '';
      this.tags.forEach(function (e, index) { if (e.url == url) num = "" + e.num + "" });
      this.removeTab(num);
      if (this.tags.length == 0) this.localmenu = ''; //清除当前正在展示的组件
    },


    /******************** 右上角操作 ****************************/
    handleCommand(id) {
      if (id == 1) this.onExit(); //退出登录
    },

    //退出登录
    onExit() {
      var token = this.$cookies.get("token");
      this.$http.post(this.GLOBAL.domain + "login/index.html", { "token": token, "act": "logout" }).then(res => {
        if (res.body.Result > 0) {
          this.$message.error(res.body.Message);
        } else {
          this.$cookies.set('selecttag', '');
          this.$cookies.remove("token");
          this.$cookies.set("token", '');
          localStorage.setItem('token', '')
          if (this.$cookies.get('record') == 0) this.$cookies.set('thumb', '');
          this.$message({ message: res.body.Message, type: 'success' });
          this.$router.push('/login')
        }
      });
    },


    //开启信息轮循（定时刷新，3分钟一次）
    getnoticeinfos() {
      //防止冒泡提示多次
      if (this.stopshowmsg == true) return false;
      this.stopshowmsg = true;

      let _this = this;
      //let token=this.$cookies.get("token");

      setInterval(function () {
        _this.$http.post(_this.GLOBAL.domain + "Notice/index.html", { "token": this.$cookies.get("token"), "act": "getnotice" }).then(res => {
          if (res.body.Result > 0) {
            _this.$message.error(res.body.Message);
          } else {
            _this.noticeLists = JSON.parse(Base64.decode(res.body.Data));
            _this.noticeLists.forEach(function (t, i) {
              t.isnew == true ? _this.messageshow = true : '';
            });

            //有新消息弹出提示
            if (_this.messageshow == true) _this.getnoticemodel();
            _this.messageshow = false;
            _this.stopshowmsg = false;
          }
        });
      }, 100000)
    },

    //跳转提示消息
    gotonotice(name, url) {
      this.noticeDialog = false;
      this.listenchild({ name: name, url: url });
    },

    //获取提示信息
    checknotice() {
      this.noticeDialog = true;
    },

    //有新消息弹出提示
    getnoticemodel() {
      let _this = this;
      this.$notify({
        title: '温馨提示',
        message: '您有新消息，请及时查看！',
        type: 'warning',
        onClick: function () {
          _this.checknotice();
        }
      });
      //播放语音
      let audio = document.getElementById('audio')
      audio.play()
    },

    //取消提示信息
    cannelnotice(val) {
      let num = -1;
      let token = this.$cookies.get("token");
      this.noticeLists.forEach(function (item, i) { item.id == val ? num = i : ''; });
      if (num != -1) {
        this.noticeLists.splice(num, 1);
        this.$http.post(this.GLOBAL.domain + "Notice/index.html", { "token": token, "act": "cannelnotice", "id": val }).then(res => {
          if (res.body.Result > 0) {
            this.$message.error(res.body.Message);
          } else {

          }
        });
      }
    },

    //铺张、拉伸主要内容
    drawandcontract() {
      this.getagent(); //获取当前页面状态（PC、移动端竖屏、移动端横屏）

      if (this.istraw == false && this.isCollapse == true) {
        this.istraw = true;
        this.isCollapse = true;
        this.leftwidth.width = '0%';
        this.rightmain.width = '100%';
        this.rightmain.left = '0%';
        this.insidecss.width = "100%";
        this.insidecss.padding = "1% 0";

      } else if (this.istraw == true && this.isCollapse == true) {
        this.istraw = false;
        this.isCollapse = true;

        //PC端
        if (this.screenstatus == 0) this.leftwidth.width = '5%';
        if (this.screenstatus == 0) this.rightmain.width = '95%';
        if (this.screenstatus == 0) this.rightmain.left = '5%';
        //移动端竖屏
        if (this.screenstatus == 1) this.leftwidth.width = '17%';
        if (this.screenstatus == 1) this.rightmain.width = '83%';
        if (this.screenstatus == 1) this.rightmain.left = '17%';
        //移动端横屏
        if (this.screenstatus == 2) this.leftwidth.width = '10%';
        if (this.screenstatus == 2) this.rightmain.width = '90%';
        if (this.screenstatus == 2) this.rightmain.left = '10%';
        this.insidecss.width = "98%";
        this.insidecss.padding = "1%";
        this.rightmain.transition = "left 0.3s";

      } else if (this.istraw == false && this.isCollapse == false) {
        this.istraw = true;
        this.isCollapse = false;
        this.leftwidth.width = '0%';
        this.rightmain.width = '100%';
        this.rightmain.left = '0%';
        this.insidecss.width = "100%";
        this.insidecss.padding = "1% 0";

      } else if (this.istraw == true && this.isCollapse == false) {
        this.istraw = false;
        this.isCollapse = true;

        //PC端
        if (this.screenstatus == 0) this.leftwidth.width = '5%';
        if (this.screenstatus == 0) this.rightmain.width = '95%';
        if (this.screenstatus == 0) this.rightmain.left = '5%';
        //移动端竖屏
        if (this.screenstatus == 1) this.leftwidth.width = '17%';
        if (this.screenstatus == 1) this.rightmain.width = '83%';
        if (this.screenstatus == 1) this.rightmain.left = '17%';
        //移动端横屏
        if (this.screenstatus == 2) this.leftwidth.width = '10%';
        if (this.screenstatus == 2) this.rightmain.width = '90%';
        if (this.screenstatus == 2) this.rightmain.left = '10%';
        this.insidecss.width = "98%";
        this.insidecss.padding = "1%";
        this.rightmain.transition = "left 0.3s";
      }

    },




    /** 线上商城商品草稿数据提交至服务器 **/
    sysmallgoodsdrafs() {
      var _this = this;
      setInterval(function () {
        _this.sysmallgoodsdrafs_data();
      }, 20000);
    },


    sysmallgoodsdrafs_data() {

      //获取草稿箱信息
      var _this = this;
      let token = this.$cookies.get("token");
      var draflists = localStorage.getItem('drafs_mall_goods_catalogue');
      if (!draflists || draflists == '') return false;

      var mallgoodsdrafs = JSON.parse(draflists);
      mallgoodsdrafs.length > 0 ? '' : mallgoodsdrafs = [];
      var syscookiename = '';
      var data = '';
      var nums = mallgoodsdrafs.length;

      mallgoodsdrafs.forEach(function (item, index) {
        syscookiename = item.name;
        data = localStorage.getItem(syscookiename);

        if (!data || data == '') { //草稿箱没有该草稿
          localStorage.setItem(syscookiename, null);
          var idx = -1;
          mallgoodsdrafs.forEach(function (tt, ii) {
            syscookiename == tt.name ? idx = ii : '';
          });
          idx >= 0 ? _this.$delete(mallgoodsdrafs, idx) : '';

          nums--;
          if (nums == 0) localStorage.setItem('drafs_mall_goods_catalogue', JSON.stringify(mallgoodsdrafs));

        } else { //草稿箱存在时，将数据提交至服务器处理
          data = JSON.parse(data);
          var goodsid = data.goodsid;
          var productid = data.productid;
          var userid = data.userid;
          var name = data.name;
          var time = data.time;
          var type = data.type;
          var data = data.data;

          _this.$http.post(_this.GLOBAL.domain + "Goods/index", { token: token, act: "savedrafsgoods", goodsid: goodsid, productid: productid, userid: userid, name: name, time: time, type: type, data: data }).then(res => {

            if (res.data.Result == '70001') return false;
            var sysresult = JSON.parse(Base64.decode(res.data.Data));

            if ((res.data.Result == 0 && sysresult.sysresult == 'success') || res.data.Result > 0) {
              _this.$message.success("保存草稿成功");
              localStorage.removeItem(syscookiename); //删除当前缓存数据

              var idx = -1;
              mallgoodsdrafs.forEach(function (tt, ii) {
                syscookiename == tt.name ? idx = ii : '';
              });

              idx >= 0 ? _this.$delete(mallgoodsdrafs, idx) : '';

              nums--;
              if (nums == 0) {
                localStorage.setItem('drafs_mall_goods_catalogue', JSON.stringify(mallgoodsdrafs));
              }

            }

          }).catch((res) => {

          });


        }

      });

    },




  },


}
</script>
<style type="text/css">
.el-header {
  background-color: #2f3036;
  color: #333;
  text-align: left;
}

.el-aside {
  position: absolute;
  background-color: #2f3036;
  color: #333;
  text-align: left;
  line-height: 200px;
  height: 100%;
  overflow: hidden;
}

.el-main {
  background-color: #EBEEF5;
  color: #333;
  text-align: left;
  line-height: 28px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
  min-height: 400px;
}

.el-menu--collapse {
  width: 100%;
}

.menulists {
  width: 100%;
  height: 90%;
  overflow-y: scroll;
}

.menulists::-webkit-scrollbar {
  width: 0;
  height: 0px;
}

.menulists .el-submenu__title i {
  color: #fff !important
}

.righthead {
  height: 30px;
  background-color: #2f3036;
  position: relative;
  overflow: hidden;
  box-shadow: 0 5px 10px #666;
  line-height: 28px;
  z-index: 1000
}

.rightheadtags {
  float: left;
  width: 80%;
}

.rightheadbutton {
  float: right;
  height: 30px;
  padding: 0 1% 0 0;
  text-align: right
}

.rightheadbutton .el-button--mini.is-circle {
  padding: 2px;
}

.rightheadbutton .el-button--info {
  background-color: #C0C4CC;
  border-color: #C0C4CC
}

.rightheadbutton .el-button--info:hover {
  background-color: #F56C6C;
  border-color: #F56C6C
}

.el-loading-spinner i {
  color: yellow;
  font-size: 18px
}

.el-loading-spinner .el-loading-text {
  color: yellow;
}

.clb-menu-logo {
  width: 22px;
  height: 22px;
  margin-right: 10px
}

/**
.el-loading-parent--relative {position:relative!important;height:0}
*/

/** 右边上部导航 **/
.rightheadtags .el-tabs__item {
  height: 30px !important;
  line-height: 30px !important;
  font-size: 12px !important;
  color: #fff !important;
  background: #2f3036 !important
}

.rightheadtags .el-tabs__item:hover {
  color: #fff !important;
  background: #C0C4CC !important;
  border-radius: 15px 15px 0 0 !important;
}

.rightheadtags .el-tabs__item.is-active {
  color: #333 !important;
  background: #fff !important;
  border-radius: 15px 15px 0 0 !important;
}

.rightheadtags .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none !important
}

.rightheadtags .el-tabs--card>.el-tabs__header .el-tabs__item {
  border: none !important
}

.rightheadtags .el-tabs--card>.el-tabs__header {
  border-bottom: none !important;
}

/** 右边下部主要内容 **/
.maincontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #d7d7d7
}

.maincontentcase {
  height: 86%;
  overflow-y: scroll
}

.maincontentcase::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.maincontentcase::-webkit-scrollbar-thumb {
  border-radius: 15px;
  -webkit-box-shadow: inset 0 0 5px rgba(220, 223, 230, 0.2);
  background: rgba(96, 98, 102, 0.4);
}

.maincontentcase::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue